import { Box } from '@mui/material';
import styled from 'styled-components';

export const MainContainer = styled(Box)({
  width: '100%',
  padding: '45px 5%',
  height: 'calc(100vh - 100px)',
  overflowY: 'auto',
});
